import { Select } from '@/components_deprecated'
import { useLanguageOptions } from '@/locale/hooks'
import { useUser } from '@/utils/hooks'
import { useMutation } from '@apollo/client'
import { useToast } from '@ur-solutions/react-components'
import { useLocale, useTranslate } from '@ur-solutions/react-hooks'
import React from 'react'
import styled from 'styled-components'
import type { PatchUserMutation, PatchUserMutationVariables } from '..'
import { PATCH_USER_MUTATION } from '../mutations'
import { Card } from './components'

const Wrapper = styled(Card)`
  grid-column: 2;
  grid-row: 2;
`

interface ChangeLanguageProps {}

export const ChangeLanguage: React.FC<ChangeLanguageProps> = () => {
  const translations = useTranslate({
    changeLanguage: 'common.change-language',

    success: {
      language: 'settings.toasts.change-language-success',
    },
    error: {
      language: 'settings.errors.change-language',
    },
  })
  const { locale, setLocale } = useLocale()

  const me = useUser()
  const addToast = useToast()

  const { languageOptions } = useLanguageOptions()

  const [patchUser] = useMutation<
    PatchUserMutation,
    PatchUserMutationVariables
  >(PATCH_USER_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: ['Bootstrap'],
    onCompleted(data) {
      if (data) addToast('success', translations.success.language)
      else addToast('error', translations.error.language)
    },
  })

  async function handleChangeLanguage(value: string | null) {
    if (!value) return
    const oldValue = locale

    setLocale(value)

    try {
      await patchUser({
        variables: {
          id: me.id,
          input: {
            language: value.toUpperCase(),
          },
        },
      })
    } catch {
      setLocale(oldValue)
    }
  }

  return (
    <Wrapper>
      <h2>{translations.changeLanguage}</h2>

      <Select
        value={locale}
        options={languageOptions}
        fullWidth
        onChange={handleChangeLanguage}
      />
    </Wrapper>
  )
}
